import { create } from 'zustand';

import type { SnackbarStore } from './snackbar.store.types';

import { notImplemented } from 'utils/notImplemented';

export const useSnackbarStore = create<SnackbarStore>((set) => ({
  createSnackbar: notImplemented,
  setCreateSnackbar: (createSnackbar) => set(() => ({ createSnackbar })),
}));
